var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidepwdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788.92-114.46 633.23-269.69q-26.54 11.77-65.88 20.73Q528-240 480-240q-131 0-238.23-71.58Q134.54-383.15 83.08-500q23.3-53 61.46-99.27 38.15-46.27 81.46-77.65l-111.54-112 28.31-28.31 674.46 674.46-28.31 28.31ZM480-353.85q14.08 0 30.88-3.3 16.81-3.31 26.27-8.62L345.77-557.15q-5.31 11-8.62 27.42-3.3 16.42-3.3 29.73 0 61.15 42.5 103.65 42.5 42.5 103.65 42.5Zm264.31 22.62L620.38-454.15q2.39-8.54 4.08-20.27t1.69-25.58q0-61.15-42.5-103.65-42.5-42.5-103.65-42.5-13.85 0-24.81 2.07-10.96 2.08-20.27 6.23l-98.15-97.38q34.85-13.15 70.92-18.96Q443.77-760 480-760q130.23 0 238.23 71.58 108 71.57 158.69 188.42-21.46 48.23-54.34 90.65-32.89 42.43-78.27 78.12ZM587.77-486 467-606q24.92-5 48.42 3.35 23.5 8.34 40.5 25.57 17.77 17.23 26.43 41.12 8.65 23.88 5.42 49.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidepwdIcon);
export default __webpack_public_path__ + "static/media/hidepwd_icon.4aef15a48fa00bc4decbccd1d1aaa4fd.svg";
export { ForwardRef as ReactComponent };